export const MEMBERSHIP_STATUSES_WITH_IDS = [
  { id: 1, label: 'New' },
  { id: 7, label: 'Provisional' },
  { id: 2, label: 'Current' },
  { id: 3, label: 'Grace' },
  { id: 4, label: 'Expired' },
  { id: 12, label: 'Moved Interstate' },
  { id: 5, label: 'Pending' },
  { id: 6, label: 'Cancelled' },
  { id: 8, label: 'Deceased' },
  { id: 10, label: 'Resigned' },
  { id: 11, label: 'Unfinancial' },
  { id: 13, label: 'Provisional - incomplete application' },
  { id: 14, label: 'Membership suspended' },
  { id: 16, label: 'Member expelled' },
  { id: 15, label: 'Application rejected' },
  { id: 17, label: 'Application withdrawn' },
];
